import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SpendingCardDeclinedTransaction } from '@webapp/models'
import { PayCardTypes } from '@webapp/models/enums'
import { DeclinedTransactionReasons } from '@webapp/modules/spending-cards/entities/enums/DeclinedTransactionReasonEnum'
import { SimplePayCardMock } from './payCard.factory'
import { PayFundMock } from './payFund.factory'
import { PayCardVendorMock } from './vendor.factory'

export const SpendingCardDeclinedTransactionMock =
  Factory.Sync.makeFactory<SpendingCardDeclinedTransaction>({
    id: Factory.each(() => faker.random.number()),
    external_id: `iauth_${faker.random.alphaNumeric(24)}`,
    vendor: Factory.each(() => PayCardVendorMock.build()),
    currency: 'USD',
    amount: Factory.each(() => faker.finance.amount()),
    vendor_currency: 'USD',
    vendor_amount: faker.finance.amount(),
    authorization_datetime: Factory.each(() =>
      faker.date.past(10).toISOString()
    ),
    card: Factory.each(() =>
      SimplePayCardMock.build({ category: PayCardTypes.VIRTUAL })
    ),
    reason: DeclinedTransactionReasons.INSUFFICIENT_FUNDS,
    fund: Factory.each(() => PayFundMock.build()),
  })
